import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a008953"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "engagement-report-table-config-options" };
const _hoisted_2 = { class: "engagement-report-table-config-options__metrics-datepicker" };
const _hoisted_3 = { class: "engagement-report-table-config-options__metrics-options" };
const _hoisted_4 = { class: "engagement-report-table-config-options__btns-options config-options-header" };
const _hoisted_5 = { class: "export-wrapper" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon ml--4 icon-down-14px" }, null, -1));
const _hoisted_7 = { class: "drop-item" };
import { useStore } from 'vuex';
import { ref, onMounted, computed } from 'vue';
import vSelect from 'vue-select';
// services
import { fetchPresets, exportTable } from '@/features/EngagementReport/data';
// components
import HeaderDatepicker from '@/components/menu/_organisms/HeaderDatepicker.vue';
// utils
import { useMixpanelSelectAggregation } from '@/utilities/mixpanel';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TableOptions',
    props: {
        hasExpandedTable: { type: Boolean }
    },
    setup(__props) {
        // libs
        // vuex
        const store = useStore();
        const metricsOptions = ref([]);
        // computed
        const user = computed(() => store.getters['user']);
        const getPreset = computed(() => store.getters['engagementReport/getPreset']);
        const getDefaultMetricsLength = computed(() => store.getters['engagementReport/getDefaultMetricsLength']);
        const getSelectedMetricsAndDimensions = computed(() => store.getters['engagementReport/getSelectedMetricsAndDimensions']);
        const getCampaignsId = computed(() => store.getters['engagementReport/getCampaignsId']);
        const getSellersId = computed(() => store.getters['engagementReport/getSellersId']);
        const getClusters = computed(() => store.getters['engagementReport/getClusters']);
        const getStoresId = computed(() => store.getters['engagementReport/getStoresId']);
        const getSelectedMetric = computed(() => store.getters['engagementReport/getMetric']);
        const metric = computed({
            get() {
                return getSelectedMetric.value;
            },
            set(newValue) {
                return setMetric(newValue);
            },
        });
        // actions
        const setEditColumnsIsVisible = (isVisible) => store.dispatch('engagementReport/setEditColumnsIsVisible', isVisible);
        const setPreset = (preset) => store.dispatch('engagementReport/setPreset', preset);
        const updateDefaultPreset = (preset) => store.dispatch('engagementReport/updateDefaultPreset', preset);
        const setIsTableExpanded = (isExpanded) => store.dispatch('engagementReport/setIsTableExpanded', isExpanded);
        const setBatchId = (batchId) => store.dispatch('engagementReport/setBatchId', batchId);
        const fetchExportJobDetails = () => store.dispatch('engagementReport/setExportJobDetails');
        const setIsModalProgressVisible = (isVisible) => store.dispatch('engagementReport/setIsModalProgressVisible', isVisible);
        const setIsModalExportErrorVisible = (isVisible) => store.dispatch('engagementReport/setIsModalExportErrorVisible', isVisible);
        const loadMetricsAndDimensions = (preset) => store.dispatch('engagementReport/loadMetricsAndDimensions', preset);
        const fetchTable = () => store.dispatch('engagementReport/setFetchTable');
        const setMetric = (metric) => store.dispatch('engagementReport/setMetric', metric);
        const openEditTableModal = () => {
            loadMetricsAndDimensions(metric.value.key);
            setEditColumnsIsVisible(true);
        };
        const selectPreset = (preset) => {
            const key = preset.key;
            useMixpanelSelectAggregation('view_oto_engagement_report_select-aggregation', key);
            setPreset(key);
        };
        const fetchPrests = () => {
            fetchPresets().then((response) => {
                metricsOptions.value = response?.presets;
            });
        };
        const formatMetricsKeys = () => {
            const hasNonPreviewMetrics = getSelectedMetricsAndDimensions.value.some(metrics => metrics.preview !== 'true');
            const hasDefaultLength = getSelectedMetricsAndDimensions.value.length === getDefaultMetricsLength.value;
            if (!hasNonPreviewMetrics && hasDefaultLength) {
                return '';
            }
            const metricKeys = getSelectedMetricsAndDimensions.value.map(metrics => metrics.key).join(',');
            return metricKeys;
        };
        const exportEngagementReportTable = (fileType) => {
            setIsModalExportErrorVisible(false);
            exportTable({
                fileType,
                metrics: formatMetricsKeys(),
                preset: getPreset.value,
                campaignId: getCampaignsId.value,
                storeId: getStoresId.value,
                sellerId: getSellersId.value,
                cluster: getClusters.value,
            })
                .then(response => {
                const batchId = response?.data?.batchId;
                setBatchId(batchId);
                setIsModalProgressVisible(true);
            })
                .catch(() => {
                setIsModalExportErrorVisible(true);
            })
                .finally(() => {
                fetchExportJobDetails();
            });
        };
        onMounted(() => {
            updateDefaultPreset(metric.value.key);
            fetchPrests();
            fetchTable();
        });
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
            const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
            const _component_el_dropdown = _resolveComponent("el-dropdown");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_unref(vSelect), {
                            modelValue: metric.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((metric).value = $event)),
                            label: "name",
                            clearable: false,
                            options: metricsOptions.value,
                            "onOption:selected": selectPreset
                        }, {
                            option: _withCtx(({ name }) => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`${name}`)), 1)
                            ]),
                            "selected-option": _withCtx(({ name }) => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`${name}`)), 1)
                            ]),
                            "open-indicator": _withCtx(({ attributes }) => [
                                _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                            ]),
                            "no-options": _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('campaign.engagement-report.no-results')), 1)
                            ]),
                            _: 1
                        }, 8, ["modelValue", "options"])
                    ]),
                    (!_ctx.hasExpandedTable)
                        ? (_openBlock(), _createBlock(HeaderDatepicker, {
                            key: 0,
                            user: user.value,
                            language: user.value?.language,
                            "conversion-window-modal": true,
                            route: "/campaigns/campaign-engagement",
                            class: "datepicker-table"
                        }, null, 8, ["user", "language"]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_el_dropdown, null, {
                            dropdown: _withCtx(() => [
                                _createVNode(_component_el_dropdown_menu, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_dropdown_item, { disabled: "" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('dashboard.options')), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_dropdown_item, { onClick: openEditTableModal }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('dashboard.edit-columns.title')), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_dropdown_item, {
                                            disabled: "",
                                            divided: ""
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('dashboard.export-data')), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_dropdown_item, {
                                            id: "csv-menu-item",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (exportEngagementReportTable('csv')))
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('dashboard.export', { value: '.CSV' })), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_dropdown_item, {
                                            id: "xls-menu-item",
                                            onClick: _cache[2] || (_cache[2] = ($event) => (exportEngagementReportTable('xls')))
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('dashboard.export', { value: '.XLS' })), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_dropdown_item, {
                                            id: "xlsx-menu-item",
                                            onClick: _cache[3] || (_cache[3] = ($event) => (exportEngagementReportTable('xlsx')))
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('dashboard.export', { value: '.XLSX' })), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                    round: "",
                                    "data-test": "dropdown-button"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('dashboard.more-options')) + " ", 1),
                                        _hoisted_6
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        (_ctx.hasExpandedTable)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                ref: "button",
                                class: "btn export",
                                onClick: _cache[4] || (_cache[4] = ($event) => (setIsTableExpanded(true)))
                            }, _toDisplayString(_ctx.$t('dashboard.expand-table')), 513))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
